let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("77Yki")).then(() => parcelRequire('fCp4X'));